module.exports = __webpack_public_path__ + "static/img/qr-code-boot.b19d103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-code-boot.png
// module id = k9CN
// module chunks = 3